import { constructFrom } from "./constructFrom.js";
import { toDate } from "./toDate.js";

/**
 *
 */

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function addDays(date, amount, options) {
  const _date = toDate(date, options?.in);
  if (isNaN(amount)) return constructFrom(options?.in || date, NaN);

  /*                                                                     */
  if (!amount) return _date;

  _date.setDate(_date.getDate() + amount);
  return _date;
}

/*                                */
export default addDays;
